<section class="sse-page" aria-labelledby="strain-library-title">
  <div class="sse-card">
    <header class="sse-header">
      <div class="sse-header-icon"><mat-icon>grass</mat-icon></div>
      <div class="sse-header-main">
        <div class="sse-eyebrow">Grow settings</div>
        <h3 id="strain-library-title">Strains</h3>
        <p>Manage the strain names used across harvests, templates, and zones.</p>
      </div>
      <div class="sse-header-actions">
        @if (canSeeLeaflogix) {
          <button class="sse-action-btn" type="button" [disabled]="refreshingStrains" (click)="refreshStrainsClick()">
            @if (refreshingStrains) {
              <i class="fa fa-spinner fa-spin"></i>
            } @else {
              <mat-icon>sync</mat-icon>
            }
            Sync Dutchie
          </button>
        }
        <button class="sse-icon-btn" type="button" aria-label="More strain actions" title="More actions" [matMenuTriggerFor]="menu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item id="strain_export_btn" (click)="export()">
            <mat-icon>file_download</mat-icon>
            <span>Export strains</span>
          </button>
          <button mat-menu-item id="strain_import_btn" (click)="import()">
            <mat-icon>file_upload</mat-icon>
            <span>Upload strains</span>
          </button>
        </mat-menu>
      </div>
    </header>

    <div class="sse-body">
      <div class="sse-add-section">
        <label class="sse-label" for="new-strain">Add a strain</label>
        <div class="sse-add-row">
          <input
            id="new-strain"
            class="sse-input"
            [(ngModel)]="newStrainName"
            (keyup.enter)="add()"
            placeholder="Enter strain name"
            autocomplete="off">
          <button class="sse-primary-btn" type="button" [disabled]="!newStrainName.trim()" (click)="add()">
            <mat-icon>add</mat-icon>Add strain
          </button>
        </div>
      </div>

      <div class="sse-library-heading">
        <div>
          <div class="sse-label">Strain library</div>
          <span class="sse-count">{{filteredStrains.length}} {{filteredStrains.length === 1 ? 'strain' : 'strains'}}</span>
        </div>
        <div class="sse-search">
          <mat-icon>search</mat-icon>
          <label class="sr-only" for="strain-search">Search strains</label>
          <input id="strain-search" [(ngModel)]="searchText" placeholder="Search strains">
          @if (searchText) {
            <button type="button" aria-label="Clear search" (click)="searchText = ''"><mat-icon>close</mat-icon></button>
          }
        </div>
      </div>

      <div class="sse-list" role="table" aria-label="Strains">
        <div class="sse-list-head" role="row">
          <span role="columnheader">Name</span>
          <span role="columnheader">Source</span>
          <span role="columnheader" class="sr-only">Actions</span>
        </div>

        @for (strain of filteredStrains; track strain.id) {
          <div class="sse-row" role="row" [class.editing]="editingStrainId === strain.id">
            @if (editingStrainId === strain.id) {
              <div class="sse-edit-field">
                <label class="sr-only" [for]="'edit-strain-' + strain.id">Strain name</label>
                <input
                  [id]="'edit-strain-' + strain.id"
                  class="sse-input"
                  [(ngModel)]="editingStrainName"
                  (keyup.enter)="applyEdit(strain)"
                  (keyup.escape)="cancelEdit()">
              </div>
            } @else {
              <span class="sse-name" role="cell">{{strain.name}}</span>
            }

            <span class="sse-source" role="cell">
              <span class="sse-source-icon"><mat-icon>{{strain.externalId ? 'sync' : 'person_outline'}}</mat-icon></span>
              {{strain.externalId ? 'Dutchie' : 'Manual'}}
            </span>

            <div class="sse-row-actions" role="cell">
              @if (editingStrainId === strain.id) {
                <button class="sse-text-btn" type="button" (click)="cancelEdit()">Cancel</button>
                <button class="sse-small-primary-btn" type="button" [disabled]="!editingStrainName.trim()" (click)="applyEdit(strain)">Done</button>
              } @else {
                <button class="sse-row-btn" type="button" [attr.aria-label]="'Edit ' + strain.name" title="Edit" (click)="edit(strain)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button class="sse-row-btn danger" type="button" [attr.aria-label]="'Remove ' + strain.name" title="Remove" (click)="remove(strain)">
                  <mat-icon>delete_outline</mat-icon>
                </button>
              }
            </div>
          </div>
        } @empty {
          <div class="sse-empty">
            <span class="sse-empty-icon"><mat-icon>{{searchText ? 'search_off' : 'grass'}}</mat-icon></span>
            @if (searchText) {
              <strong>No matching strains</strong>
              <span>No strains match “{{searchText}}”.</span>
            } @else {
              <strong>No strains yet</strong>
              <span>Add your first strain above.</span>
            }
          </div>
        }
      </div>

      @if (canSeeLeaflogix) {
        <p class="sse-sync-note"><mat-icon>info_outline</mat-icon>Dutchie sync replaces the saved strain list.</p>
      }
    </div>
  </div>

  @if (dirty) {
    <div class="sse-savebar" role="status">
      <span class="sse-savebar-dot"></span>
      <span class="sse-savebar-msg">Unsaved changes</span>
      <span class="sse-savebar-spacer"></span>
      <button class="sse-save-btn ghost" type="button" [disabled]="saving" (click)="getStrains()">Discard</button>
      <button class="sse-save-btn primary" type="button" [disabled]="saving" (click)="save()">
        @if (saving) {
          <mat-spinner diameter="18" strokeWidth="3"></mat-spinner>
        } @else {
          <mat-icon>save</mat-icon>
        }
        Save changes
      </button>
    </div>
  }
</section>
